// A hook which allows us to use Dwolla's drop-in components.

// This is mounted in DwollaEntrepreneurSetupComponent (and in the future,
// DwollaInvestorSetupComponent), and sends a request to our server to fetch a
// client token from Dwolla via a backend API. This token is then used to
// configure the drop-in components.

// Responses from the drop-in components are sent to the server via a LiveView
// event, where we react on them.
import appsignal from "../appsignal";
import { isProd } from "../utils";

const DwollaHook = {
  mounted() {
    const mainsharesApiToken = this.el.dataset.mainsharesApiToken;
    const dwollaEnvironment = isProd ? "production" : "sandbox";

    dwolla.configure({
      environment: dwollaEnvironment,
      success: (res) => {
        Promise.resolve(this.pushEventTo(this.el, "dwolla:success", res));
      },
      error: (err) => Promise.resolve(appsignal.sendError(err)),
      token: (req) =>
        Promise.resolve(fetchClientToken(req, { mainsharesApiToken })),
    });
  },
};

// borrowed heavily from https://developers.dwolla.com/docs/drop-in-components/drop-ins/generate-client-token#using-token
function fetchClientToken(req, { mainsharesApiToken }) {
  const tokenUrl = "/api/dwolla/client-token";
  const data = { action: req.action };
  if (req.links) {
    data._links = req.links;
  }
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Requested-With": "Dwolla-Drop-Ins-Library",
    "mainshares-api-token": mainsharesApiToken,
  };
  return fetch(`${tokenUrl}`, {
    credentials: "include",
    method: "POST",
    body: JSON.stringify(data),
    headers,
  })
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("error fetching token:", error);
      return error;
    });
}

export default DwollaHook;
